import React from "react";

export const RefreshButton: React.FC<{
	isFetching: boolean;
	onRefresh: () => void;
}> = ({ isFetching, onRefresh }) => (
	<div className="flex justify-center py-2">
		<button
			className="cursor-pointer rounded-md border border-gray-300 bg-white px-4 py-1.5 text-gray-700 text-sm hover:bg-gray-100 disabled:opacity-50"
			disabled={isFetching}
			onClick={onRefresh}
			type="button"
		>
			{isFetching ? "Refreshing..." : "Refresh"}
		</button>
	</div>
);
